import { Accepts, Types } from "@citychallenge/common";
import { Inlet } from "../../reactive";
import { defineElement } from "../define-element";

export class LeaderboardProps {
  @Inlet(Accepts.Image) public image?: Types["Image"];
  @Inlet(Accepts.MarkdownText) public text?: Types["MarkdownText"];
  @Inlet(Accepts.LeaderboardType) public type?: Types["LeaderboardType"];
}

export const LeaderboardDefinition = defineElement(
  "leaderboard",
  LeaderboardProps,
  {
    versionRequired: "0.58.0",
  }
);
